<template>
    <custom-table
        :title="$t('pages.user.title')"
        :subTitle="$t('pages.user.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        filterComponentName="UserFilter"
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:firstname="{ row: record }">
            {{ record.firstname }}
        </template>
        <template v-slot:lastname="{ row: record }">
            {{ record.lastname }}
        </template>
        <template v-slot:email="{ row: record }">
            {{ record.email }}
        </template>
        <template v-slot:mobile_phone="{ row: record }">
            {{ record.mobile_phone }}
        </template>
        <template v-slot:active="{ row: record }">
            <span :class="record.active ? 'badge-light-success': 'badge-light-danger'" class="badge">{{ record.active ? $t('common.active') : $t('common.passive') }}</span>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <router-link :to="'/user/save/' + record.id" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                     </span>
                    </router-link>
                </el-tooltip>
                <el-tooltip :content="$t('pages.user.changePassword')" placement="top">
                    <button class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" @click="changePassword(record)">
                        <span class="svg-icon svg-icon-3">
                               <inline-svg src="/media/icons/duotune/general/gen047.svg"/>
                        </span>
                    </button>
                </el-tooltip>
                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_change_password" ref="changePasswordModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_change_password_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_change_password_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onChangePasswordSubmit()" :model="form.data" ref="changePasswordForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_change_password_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.currentPassword') }}</label>
                                <el-form-item prop="password" :rules="rules.current_password">
                                    <el-input v-model="form.data.current_password" autocomplete="off" type="password"/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.password') }}</label>
                                <el-form-item prop="password" :rules="rules.password">
                                    <el-input v-model="form.data.password" autocomplete="off" type="password"/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.user.cols.passwordConfirmation') }}</label>
                                <el-form-item prop="password_confirmation" :rules="rules.password_confirmation">
                                    <el-input v-model="form.data.password_confirmation" autocomplete="off" type="password"/>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "user",
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.user.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.user.cols.firstname"),
                    scopedSlots: {customRender: "firstname"}
                },
                {
                    name: this.$t("pages.user.cols.lastname"),
                    scopedSlots: {customRender: "lastname"}
                },
                {
                    name: this.$t("pages.user.cols.email"),
                    scopedSlots: {customRender: "email"}
                },
                {
                    name: this.$t("pages.user.cols.mobilePhone"),
                    scopedSlots: {customRender: "mobile_phone"},
                },
                {
                    name: this.$t("pages.user.cols.active"),
                    scopedSlots: {customRender: "active"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                currentForm: 'changePasswordForm',
                data: {
                    password: '',
                    password_confirmation: '',
                }
            },
            rules: {},
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false
        }
    },
    created() {
        this.rules = {
            password: [{validator: this.validatePass, trigger: ['blur']}],
            password_confirmation: [{validator: this.validatePass2, trigger: ['blur', 'change']}],
        }
    },
    computed: {
        table() {
            return this.$store.state.user.table;
        },
        userID() {
            return this.$route.query.userID;
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.userManagement"), []);

        this.filterParameters = {
            id: this.userID,
            sort: 'created_at:desc'
        };

        this.$store.dispatch('user/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
        });
    },
    methods: {
        validatePass(rule, value, callback) {
            if (value === '') {
                callback(new Error(this.$t('validation.password')))
            } else {
                if (this.form.data.password_confirmation !== '') {
                    this.$refs[this.form.currentForm].validateField('password_confirmation')
                }
                callback()
            }
        },
        validatePass2(rule, value, callback) {
            if (value === '') {
                callback(new Error(this.$t('validation.passwordConfirmation')))
            } else if (value !== this.form.data.password) {
                callback(new Error(this.$t('validation.dontMatchPassword')))
            } else {
                callback()
            }
        },
        changePassword(record) {
            this.form.currentForm = 'changePasswordForm';
            this.form.title = this.$t("pages.user.changePassword");

            this.form.data = {
                id: record.id,
                password: '',
                password_confirmation: ''
            };

            this.showModal(this.$refs.changePasswordModal);
        },
        onChangePasswordSubmit() {
            console.log("submit pass");
            this.$refs.changePasswordForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.form.data.id) {
                        this.axios.put(this.endpoints['user_change_password'] + '/' + this.form.data.id, this.form.data).then(response => {
                            this.onResponse(response.data, () => {
                                this.hideModal(this.$refs.changePasswordModal);
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.$router.push({
                        path: "/user/save"
                    });
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('user/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("user/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("user/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
    }
}
</script>

<style scoped>

</style>